const settings = [
  {
      "id": "1",
      "uuid": "05f244e1-e29a-4f83-a878-e340a5e21619",
      "name": "precision",
      "label": "Precision",
      "type": "radio",
      "value": "2",
      "options": [
          {
              "id": "1",
              "label": "Whole",
              "value": "1"
          },
          {
              "id": "2",
              "label": "Half",
              "value": "2"
          },
          {
              "id": "3",
              "label": "Quarter",
              "value": "4"
          },
          {
              "id": "34",
              "label": "Tenth",
              "value": "10"
          }
      ]
  },
  {
      "id": "3",
      "uuid": "47556ec1-860b-43ac-a54f-1b720116a78d",
      "name": "unitOfMeasurement",
      "label": "Unit of Measurement",
      "type": "radio",
      "value": "decimalFeet",
      "options": [
          {
              "id": "5",
              "label": "Meters",
              "value": "meters"
          },
          {
              "id": "4",
              "label": "Feet/Decimal",
              "value": "decimalFeet"
          },
          {
              "id": "6",
              "label": "Feet/Inches",
              "value": "feet"
          }
      ]
  },
  {
      "id": "2",
      "uuid": "e848ce82-fd85-4b72-930d-fb6d160a1ba0",
      "name": "gridLines",
      "label": "Grid Lines",
      "type": "radio",
      "value": "light",
      "options": [
          {
              "id": "7",
              "label": "Off",
              "value": "off"
          },
          {
              "id": "9",
              "label": "Light",
              "value": "light"
          },
          {
              "id": "8",
              "label": "Dark",
              "value": "dark"
          }
      ]
  },
  {
      "id": "5",
      "uuid": "a8dea264-603b-4202-8f3f-e87ebdbcb241",
      "name": "exteriorWallDesktop",
      "label": "Desktop",
      "type": "radio",
      "value": "disabled",
      "options": [
          {
              "id": "10",
              "label": "Enabled",
              "value": "enabled"
          },
          {
              "id": "11",
              "label": "Disabled",
              "value": "disabled"
          }
      ]
  },
  {
      "id": "6",
      "uuid": "fad35f42-44d8-45f4-ad0e-bd7e71613096",
      "name": "exteriorWallMobile",
      "label": "Mobile",
      "type": "radio",
      "value": "enabled",
      "options": [
          {
              "id": "13",
               "label": "Enabled",
              "value": "enabled"
          },
          {
              "id": "12",
              "label": "Disabled",
              "value": "disabled"
          }
      ]
  },
  {
      "id": "7",
      "uuid": "68436fcc-cf58-4354-b17b-f4fd78f55000",
      "name": "interiorWallDesktop",
      "label": "Desktop",
      "type": "radio",
      "value": "disabled",
      "options": [
          {
              "id": "14",
              "label": "Enabled",
              "value": "enabled"
          },
          {
              "id": "15",
              "label": "Disabled",
              "value": "disabled"
          }
      ]
  },
  {
      "id": "8",
      "uuid": "75d402bf-5baf-4944-8cc9-3c65683b7039",
      "name": "interiorWallMobile",
      "label": "Mobile",
      "type": "radio",
      "value": "enabled",
      "options": [
          {
              "id": "17",
              "label": "Enabled",
              "value": "enabled"
          },
          {
              "id": "18",
              "label": "Disabled",
              "value": "disabled"
          }
      ]
  },
  {
      "id": "4",
      "uuid": "85b14019-b127-4a9b-a478-b0a630acc9f7",
      "name": "gridSizeInFeet",
      "label": "Grid Scale",
      "type": "static",
      "value": "1",
      "options": []
  }
]

export default settings;